import templates, { getTemplate } from '../../ui/widgets/resource-entry/templates';

const _titleWidth = 150;
const _upsideDownsideTitleWidth = 180;
const _laborRateWidth = 120;
const _projectedWidth = 150;
const _diffWidth = 120;
const _actualWidth = 120;

const id = $('[name="Id"]').val();

const flatSchema = {
    model: {
        id: 'Id',
        fields: {
            Id: {editable: false},
            ScheduleFiveId: {editable: false},
            ItemName: {editable: false},
            ProjectedCost: {editable: false},
            Difference: {editable: false},
            ActualCost: {editable: false},
            Values: {editable: true}
        }
    }
};
const laborSchema = {
    model: {
        id: 'Id',
        fields: {
            Id: {editable: false},
            ScheduleFiveId: {editable: false},
            ItemName: {editable: false},
            LaborRate: {editable: false},
            ProjectedHours: {editable: false},
            Difference: {editable: false},
            ActualHours: {editable: false},
            ActualCost: {editable: false},
            Values: {editable: true}
        }
    }
};
const forecastedSchema = {
    model: {
        id: 'title',
        fields: {
            title: {editable: false},
            format: {editable: false},
            Values: {editable: true},
            total: {editable: false}
        }
    }
};
const billingForecastSchema = {
    model: {
        id: 'ItemName',
        fields: {
            Id: {editable: false},
            ScheduleFiveId: {editable: false},
            title: {editable: false},
            ItemName: {editable: false},
            ProjectedCost: {editable: false},
            Variance: {editable: false},
            ActualCost: {editable: false},
            Values: {editable: true},
            total: {editable: true}
        }
    }
};
const targetBillingsSchema = {
    model: {
        id: 'title',
        fields: {
            Id: {editable: false},
            ScheduleFiveId: {editable: false},
            title: {editable: false},
            ProjectedCost: {editable: false},
            Difference: {editable: false},
            ActualCost: {editable: false},
            Values: {editable: true}
        }
    }
};
export const costSchema = {
    model: {
        id: 'Id',
        fields: {
            Id: {editable: false},
            ScheduleFiveId: {editable: false},
            ItemName: {editable: false},
            ProjectedCost: {editable: false},
            Difference: {editable: false},
            ActualCost: {editable: false},
            Values: {editable: true}
        }
    }
};
const upsideDownsideSchema = {
    model: {
        id: 'ItemName',
        fields: {
            Id: {editable: false},
            ItemName: {editable: false},
            UnspreadCost: {editable: false},
            Variance: {editable: true},
            Total: {editable: false},
            Values: {editable: true}
        }
    }
};
const upsideDownsideAdditionalSchema = {
    data: 'Additionals',
    model: {
        id: 'ItemName',
        fields: {
            Id: {editable: false},
            ItemName: {editable: false},
            Total: {editable: true},
            Values: {editable: true}
        }
    }
};
export const projectedStaticColumns = [
    {
        field: 'title',
        type: 'string',
        title: '&nbsp;',
        width: _titleWidth + _laborRateWidth,
        editable: false
    },
    {
        field: 'total',
        type: 'number',
        template: templates.columnBased('total', 'format'),
        title: 'Total',
        width: _titleWidth + _laborRateWidth,
        editable: false,
    }
];
export const targetBillingsStaticColumns = [{
    field: 'title',
    type: 'string',
    title: '&nbsp;',
    width: _titleWidth + _laborRateWidth + 10,
    editable: false
}, {
    field: 'total',
    type: 'number',
    title: '&nbsp;',
    width: _titleWidth + _laborRateWidth - 10,
    template: templates.columnBased('total', 'format'),
    editable: false
}
];
export const forecastedBillingsStaticColumns = [
    {
        field: 'ItemName',
        type: 'string',
        title: '&nbsp;',
        width: _upsideDownsideTitleWidth - 30,
        editable: false
    },
    {
        field: 'ProjectedCost',
        template: templates.currencyClipped('ProjectedCost'),
        type: 'currency',
        title: 'Projected Revenue',
        width: _diffWidth + 10,
        editable: false
    },
    {
        field: 'Difference',
        template: templates.currencyClipped('Difference'),
        type: 'currency',
        title: 'Variance',
        width: _diffWidth + 10,
        editable: false
    },
    {
        field: 'ActualCost',
        template: templates.currencyClipped('ActualCost'),
        type: 'currency',
        title: 'Billings To Date',
        width: _diffWidth + 10,
        editable: false
    }
];
export const upsideDownsideColumns = [
    {
        field: 'ItemName',
        type: 'string',
        title: '&nbsp;',
        width: _upsideDownsideTitleWidth,
        editable: false
    },
    {
        field: 'UnspreadCost',
        type: 'number',
        title: 'Unspread Cost',
        width: _diffWidth,
        editable: false
    },
    {
        field: 'Variance',
        template: templates.numberClipped('Variance'),
        type: 'number',
        title: 'Variance',
        width: _diffWidth,
        editable: false
    },
    {
        field: 'Total',
        type: 'currency',
        title: 'Total Upside/Downside',
        width: _diffWidth,
        editable: false
    }
];
export const upsideDownsideAdditionalColumns = [
    {
        field: 'ItemName',
        type: 'string',
        title: '&nbsp;',
        width: _upsideDownsideTitleWidth + _diffWidth + _diffWidth,
        editable: false
    },
    {
        field: 'Total',
        type: 'currency',
        title: 'Total Upside/Downside',
        width: _diffWidth,
        editable: false
    }
];
export const flatStaticColumns = [
    {
        field: 'ItemName',
        type: 'string',
        title: '&nbsp;',
        width: _titleWidth + _laborRateWidth,
        editable: false
    },
    {
        field: 'ProjectedCost',
        template: templates.currencyClipped('ProjectedCost'),
        type: 'currency',
        title: 'Projected Cost',
        width: _projectedWidth,
        editable: false,
        aggregates: ['sum'],
        footerTemplate: templates.currencyClipped('sum')
    },
    {
        field: 'Difference',
        template: templates.currencyClipped('Difference'),
        type: 'currency',
        title: 'Variance',
        width: _diffWidth,
        editable: false,
        aggregates: ['sum'],
        // The column total is as wide as the widest cell above it and narrower than the sum
        // it holds, so it clips the same way. The aggregate arrives as 'sum'.
        footerTemplate: templates.currencyClipped('sum')
    },
    {
        field: 'ActualCost',
        template: templates.currencyClipped('ActualCost'),
        type: 'currency',
        title: 'Actual Cost',
        width: _actualWidth,
        editable: false,
        aggregates: ['sum'],
        footerTemplate: templates.currencyClipped('sum')
    }
];
// The warning marks a cost code with no projected hours. It goes in the clipped cell's fixed
// slot, so the number beside it can still shrink to an ellipsis; previously both were floats,
// which is why this column wrapped as well. The icon is left out of the hover text.
const projectedHoursTemplate = (field) => {
    const icon = $('<span class="k-icon k-i-warning --warning js-warning-tooltip">&nbsp;</span>');
    const warning = `#=ProjectedHours == 0 ? '${icon[0].outerHTML}' : ''#`;
    return templates.numberClipped(field, warning);
};
export const laborStaticColumns = [
    {
        field: 'ItemName',
        type: 'string',
        title: '&nbsp;',
        width: _titleWidth,
        editable: false
    },
    {
        field: 'LaborRate',
        type: 'currency',
        title: 'Labor Rate',
        width: _laborRateWidth,
        editable: false
    },
    {
        field: 'ProjectedHours',
        type: 'number',
        title: 'Projected Hours',
        width: _projectedWidth,
        editable: false,
        template: projectedHoursTemplate('ProjectedHours')
    },
    {
        field: 'Difference',
        template: templates.numberClipped('Difference'),
        type: 'number',
        title: 'Variance',
        width: _diffWidth,
        editable: false
    },
    {
        field: 'ActualHours',
        template: templates.numberClipped('ActualHours'),
        type: 'number',
        title: 'Actual Hours',
        width: _actualWidth,
        editable: false
    }
];
export const costStaticColumns = [
    {
        field: 'ItemName',
        type: 'string',
        title: '&nbsp;',
        width: _titleWidth + _laborRateWidth,
        editable: false
    },
    {
        field: 'ProjectedCost',
        template: templates.currencyClipped('ProjectedCost'),
        type: 'currency',
        title: 'Projected Cost',
        width: _projectedWidth,
        editable: false,
        aggregates: ['sum'],
        footerTemplate: templates.currencyClipped('sum')
    },
    {
        field: 'Difference',
        template: templates.currencyClipped('Difference'),
        type: 'currency',
        title: 'Variance',
        width: _diffWidth,
        editable: false,
        aggregates: ['sum'],
        // The column total is as wide as the widest cell above it and narrower than the sum
        // it holds, so it clips the same way. The aggregate arrives as 'sum'.
        footerTemplate: templates.currencyClipped('sum')
    },
    {
        field: 'ActualCost',
        template: templates.currencyClipped('ActualCost'),
        type: 'currency',
        title: 'Actual Cost',
        width: _actualWidth,
        editable: false,
        aggregates: ['sum'],
        footerTemplate: templates.currencyClipped('sum')
    }
];
const updateTotal = function (e, template) {
    const {action, items} = e;
    const me = this;
    const $grid = me.options.schema.resourceEntry.grid.element;
    $.each(items, (i, v) => {
        const myItem = items[i];
        if (myItem.title === "Percent Over/(Under) Billed") return;
        const {uid} = v;
        const totalKey = Object.keys(myItem).find(key => key.toLowerCase() === 'total');
        myItem[totalKey] = myItem.rowSum();
        const columnId = $grid.find('[data-field]').filter(function () {
            const that = $(this);
            return that.data('field').toLowerCase() === 'total';
        }).attr('id');
        $grid.find(`[data-uid="${uid}"]`).find(`[aria-describedby="${columnId}"]`).html(template(myItem));
    });
    return e;
};

/* ---------------------------------------------------------------------------
   Variance rendering.

   Nothing here calculates a variance. The calculation lives in the database, in
   dbo.scheduleFive_resourceVariance and vScheduleFive_resourceVariance, and reaches
   this page two ways:

     - on load, from /Operations/ScheduleFive/GetVarianceSummary, which returns the
       tag state for all nine cost types;
     - after an edit, from the save response, which returns the edited row's new
       variance and its cost type's tag state.

   Keeping the arithmetic out of the browser is the point: the Schedule 5 overview
   grid and this page previously each had their own copy and drifted apart. It also
   means a tag updates once the save round trip completes rather than on keystroke.
   --------------------------------------------------------------------------- */

export const buildVarianceTagState = isWithinTolerance =>
    isWithinTolerance
        ? { text: 'No Variance', addClass: 'tag--green', removeClass: 'tag--red' }
        : { text: 'Variance', addClass: 'tag--red', removeClass: 'tag--green' };

// The server sends a SQL bit, so accept 1 / '1' / 'true' as well as a real boolean.
export const isWithinTolerance = flag =>
    flag === true || flag === 1 || flag === '1' || String(flag).toLowerCase() === 'true';

// Paint one cost type's tag. No-ops for a cost type with no tag on the page, which
// is why the hook is the explicit js-variance-tag class rather than .tag: the
// projections and billing sections carry unrelated .tag elements.
export const paintVarianceTag = (costType, withinTolerance) => {
    const $tag = $(`.js-variance-tag[data-cost-type="${costType}"]`);
    if (!$tag.length) return;

    const { text, addClass, removeClass } = buildVarianceTagState(isWithinTolerance(withinTolerance));
    $tag.text(text).removeClass(removeClass).addClass(addClass).show();
};

// Paint every tag from one GetVarianceSummary response.
export const applyVarianceSummary = rows =>
    (rows ?? []).forEach(row => paintVarianceTag(row?.costType, row?.isWithinTolerance));

// Fetch the summary and paint all nine tags. Called once the page has loaded rather
// than per grid, so a cost type whose section has never been opened still shows the
// right tag.
export const loadVarianceSummary = scheduleFiveId =>
    $.getJSON(`/Operations/ScheduleFive/GetVarianceSummary`, { id: scheduleFiveId })
        .done(applyVarianceSummary);

// The payload handed back to Kendo on a successful save. It has to carry the server's
// Difference, because Kendo merges this object onto the row model and anything absent
// keeps whatever the browser last had. Falls back to the posted row when the server
// returned nothing, so a missing response cannot blank the cell.
export const mergeSavedDifference = (postedRow, result) =>
    result && result.difference !== undefined && result.difference !== null
        ? { ...postedRow, Difference: result.difference }
        : postedRow;

// Apply a save response: update the edited row's variance on its grid, on the companion
// cost grid for a labor row, and repaint that cost type's tag. Editing a row can only
// move its own cost type's total, so the other eight tags are left alone.
export const applyVarianceSaveResult = (result, rowId) => {
    if (!result) return;

    const className = _costTypeClassNames[result.costType];
    if (className) {
        // The section's own grid: hours for a labor type, dollars for a cost type.
        setGridRowDifference(`.js-${className}-grid:not(.js-cost)`, rowId, result.difference);
        // A labor section shows the same row again in dollars in its companion grid.
        setGridRowDifference(`.js-${className}-grid.js-cost`, rowId, result.differenceCost);
    }

    paintVarianceTag(result.costType, result.isWithinTolerance);
};

// The value has to land on the model rather than in the cell. Two reasons: Difference is
// declared editable: false, so Kendo's set() would silently ignore it; and the grid
// re-binds from the model once the save completes, which would overwrite anything painted
// into the cell by hand. So assign the field directly and let the grid re-render.
const setGridRowDifference = (selector, rowId, value) => {
    if (value === undefined || value === null) return;

    const resourceEntry = $(selector).data('kendoResourceEntry');
    const dataItem = resourceEntry?.dataSource?.get(rowId);
    if (!dataItem) return;

    dataItem.Difference = value;
    resourceEntry.grid?.refresh();
};

// Maps a server cost type onto the grid class used in ScheduleFive.cshtml. Note that
// generalConditions maps to a singular class name, and that these strings also have to
// match the data-cost-type attributes on the variance tags.
const _costTypeClassNames = {
    equipment: 'equipment',
    material: 'material',
    projectControl: 'project-control',
    bim: 'bim',
    shopLabor: 'shop-labor',
    fieldLabor: 'field-labor',
    subcontractors: 'subcontractors',
    otherCosts: 'other-costs',
    generalConditions: 'general-condition',
};
const totalTemplate = kendo.template(getTemplate('currency')('total'));
export const updateRowTotal = function (e) {
    return updateTotal.apply(this, [e, totalTemplate]);
};
const upsideUnspreadCostTemplate = kendo.template(getTemplate('currency')('UnspreadCost'));
export const updateUpsideVariance = function (me, e) {
    const {action, items} = e;
    const $grid = me.options.schema.resourceEntry.grid.element;
    $.each(items, (i, v) => {
        const myItem = items[i];
        const {UnspreadCost, Total, uid} = v;
        myItem.Variance = UnspreadCost - myItem.rowSum();
        const columnId = $grid.find('[data-field="Variance"]').attr('id');
        $grid.find(`[data-uid="${uid}"]`).find(`[aria-describedby="${columnId}"]`).html(upsideUnspreadCostTemplate(myItem));
    });
    return e;
};
const upsideTotalTemplate = kendo.template(getTemplate('currency')('Total'));
export const updateUpsideRowTotal = function (me, e) {
    return updateTotal.apply(me, [e, upsideTotalTemplate]);
};
const differenceTemplate = kendo.template(getTemplate('currency')('Difference'));
const updateForecastBillingDifference = function (me, e) {
    const {items} = e;
    const $grid = me.options.schema.resourceEntry.grid.element;
    $.each(items, (i, v) => {
        const myItem = items[i];
        const {ProjectedCost, ActualCost, uid} = v;
        myItem.Difference = ProjectedCost - ActualCost - myItem.rowSum();
        const columnId = $grid.find('[data-field="Difference"]').attr('id');
        $grid.find(`[data-uid="${uid}"]`).find(`[aria-describedby="${columnId}"]`).html(differenceTemplate(myItem));
    });
    return e;
}
export const projectedData = {
    schema: forecastedSchema,
    transport: {
        read: {
            url: `/Operations/ScheduleFive/ProjectedData/${id}`,
            dataType: 'json'
        }
    },
    sync: function (params) {
        refreshUpsideDownside();
    }
};

// ─── Derived Projected Grid ────────────────────────────────────────────────
// Reads from the persisted derivedData table; returns the same shape as
// ProjectedData so it is a drop-in replacement for the top grid datasource.
export const derivedProjectedData = {
    schema: forecastedSchema,
    transport: {
        read: {
            url: `/Operations/ScheduleFive/DerivedData?id=${id}`,
            dataType: 'json',
        }
    },
    sync: function() {
        refreshUpsideDownside();
    }
};

export const forecastedBillingsData = {
    schema: billingForecastSchema,
    transport: {
        read: {
            url: `/Operations/ScheduleFive/ForecastedBillingData/${id}`,
            dataType: 'json'
        },
        update: {
            url: '/Operations/ScheduleFive/SaveForecastedBillingData',
            dataType: 'json'
        }
    },
    change(e) {
        updateForecastBillingDifference(this, e);
    },
    sync: function (params) {
        refreshTargetBillingsGrids();
    }
};
export const targetBillingsData = {
    schema: targetBillingsSchema,
    transport: {
        read: {
            url: `/Operations/ScheduleFive/TargetBillingData/${id}`,
            dataType: 'json'
        }
    },
    change: updateRowTotal,
    sync: function (params) {
        // updateRowTotal(params);
        refreshTargetBillingsGrids();
    }
};
export const upsideDownsideData = {
    schema: upsideDownsideSchema,
    transport: {
        read: {
            url: `/Operations/ScheduleFive/UpsideDownsideData/${id}`,
            dataType: 'json'
        },
        update: {
            url: '/Operations/ScheduleFive/UpdateUpsideDownsideData',
            dataType: 'json'
        }
    },
    change(e) {
        updateUpsideRowTotal(this, e);
        updateUpsideVariance(this, e);
    },
    // The projected and additional grids are both built from derived data that the
    // server recalculates as part of this save, so they are re-read once it has come
    // back. Refreshing them from change() instead re-read them on every load, because
    // change() fires on the grid's own read as well as on an edit, and on an edit it
    // read before saveRow() had synced, so the numbers came back pre-save. This grid
    // itself is not re-read: the save response carries the row's new values and the
    // client recalculates Variance and Total from them.
    sync() {
        refreshProjectedGrid();
        refreshUpsideDownsideAdditional();
    }
};
export const upsideDownsideAdditionalData = {
    schema: upsideDownsideAdditionalSchema,
    transport: {
        read: {
            url: `/Operations/ScheduleFive/GetUpsideDownsideAdditionalData/${id}`,
            dataType: 'json'
        },
    },
    change(e) {
        updateUpsideRowTotal(this, e);
    }
};

function getDataSourceDefinition(dataSourceOptions) {

    return {
        schema: dataSourceOptions.schema,
        transport: {
            read: function(options) {
                $.ajax({
                    url: dataSourceOptions.readUrl,
                    type: 'GET',
                    dataType: 'json',
                    success: function(result) {
                        options.success(result);
                    },
                    error: function(xhr, status, error) {
                        options.error(xhr);
                    },
                });
            },

            // Difference is no longer computed here and posted. The sproc calculates
            // it from the monthly values and returns the stored result, so the browser
            // is not a writer to a column that reporting reads.
            update: function(options) {
                const rowId = options.data?.Id;

                $.ajax({
                    url: dataSourceOptions.updateUrl,
                    type: 'GET',
                    dataType: 'json',
                    data: { ...options.data },
                    success: function(result) {
                        // Whatever is handed to options.success is merged onto the row
                        // model by Kendo's accept(), which is how a server-calculated
                        // value gets back onto the row: accept() is not subject to the
                        // field's editable: false. Passing options.data on its own would
                        // write the stale value the browser sent back over Difference,
                        // which is why the row's Variance never moved.
                        options.success(mergeSavedDifference(options.data, result));
                        applyVarianceSaveResult(result, rowId);
                    },
                    error: function(result) {
                        options.error(result);
                    },
                });
            },
        },
        sync: function(params) {
            const that = this;
            that.trigger('change');
            refreshTopGrids();
        },
    };
}

const equipmentDataOptions = {
    schema: flatSchema,
    readUrl: `/Operations/ScheduleFive/EquipmentData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveEquipmentData',
    amountType: 'cost',
}

export const equipmentData = getDataSourceDefinition(equipmentDataOptions);

const materialDataOptions = {
    schema: flatSchema,
    readUrl: `/Operations/ScheduleFive/MaterialData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveMaterialData',
    amountType: 'cost',
};

export const materialData = getDataSourceDefinition(materialDataOptions);

const projectControlDataOptions = {
    schema: laborSchema,
    readUrl: `/Operations/ScheduleFive/ProjectControlData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveProjectControlData',
    amountType: 'hours',
};

export const projectControlData = getDataSourceDefinition(projectControlDataOptions);

const bimDataOptions = {
    schema: laborSchema,
    readUrl: `/Operations/ScheduleFive/BimData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveBimData',
    amountType: 'hours',
}

export const bimData = getDataSourceDefinition(bimDataOptions);

const shopLaborDataOptions = {
    schema: laborSchema,
    readUrl: `/Operations/ScheduleFive/ShopLaborData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveShopLaborData',
    amountType: 'hours',
}

export const shopLaborData = getDataSourceDefinition(shopLaborDataOptions);

const fieldLaborDataOptions = {
    schema: laborSchema,
    readUrl: `/Operations/ScheduleFive/FieldLaborData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveFieldLaborData',
    amountType: 'hours',
}

export const fieldLaborData = getDataSourceDefinition(fieldLaborDataOptions);

const subContractorDataOptions = {
    schema: flatSchema,
    readUrl: `/Operations/ScheduleFive/SubcontractorData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveSubcontractorData',
    amountType: 'cost',
}

export const subcontractorData = getDataSourceDefinition(subContractorDataOptions);

const otherCostsDataOptions = {
    schema: flatSchema,
    readUrl: `/Operations/ScheduleFive/OtherCostsData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveOtherCostsData',
    amountType: 'cost',
}

export const otherCostsData = getDataSourceDefinition(otherCostsDataOptions);

const generalConditionsDataOptions = {
    schema: flatSchema,
    readUrl: `/Operations/ScheduleFive/GeneralConditionsData/${id}`,
    updateUrl: '/Operations/ScheduleFive/SaveGeneralConditionsData',
    amountType: 'cost',
}

export const generalConditionsData = getDataSourceDefinition(generalConditionsDataOptions);

/* ---------------------------------------------------------------------------
   Refreshing the grids above the cost sections.

   Each helper reads one grid and nothing else. Reads used to be chained off other
   grids' events: reading a grid raised change, change read the next grid, and that
   grid's dataBound read the one after it. One save became seven requests, and a page
   load asked DerivedData, UpsideDownsideData and GetUpsideDownsideAdditionalData for
   the same data three and four times over.

   Nothing in here may read a grid other than its own, and no grid event handler may
   call one of these directly. A caller that needs several grids refreshed asks for
   each of them, which is what refreshTopGrids does.

   readEntry tolerates a missing grid because the billing forecast section is only
   rendered above a contract amount threshold.
   --------------------------------------------------------------------------- */

const readEntry = (selector) => {
    const resourceEntry = $(selector).data('kendoResourceEntry');
    if (!resourceEntry) return;
    resourceEntry.dataSource.read();
};

const refreshProjectedGrid = () => readEntry('.js-projected-grid');

const refreshTargetBillingsGrids = () => readEntry('.js-target-billings-grid');

const refreshUpsideDownside = () => readEntry('.js-upside-downside');

const refreshUpsideDownsideAdditional = () => readEntry('.js-upside-downside-additional');

// A save in any cost section moves the totals every one of these grids is derived
// from, so all four are re-read. The reads are issued together rather than chained,
// so they overlap instead of queueing behind one another.
export const refreshTopGrids = () => {
    refreshProjectedGrid();
    refreshTargetBillingsGrids();
    refreshUpsideDownside();
    refreshUpsideDownsideAdditional();
};
